import {React, observer, useAsync, classNames, toJS, pluralize} from '@api'
import {Spinner} from '@blueprintjs/core'
import {Tooltip2} from '@api'

import {Tooltip} from '@material-ui/core'
import {useGroupByGroupStore} from '@modules'
import { CatalogPerspectiveConfig, useCatalog} from '@stores'
import {NumberBadge} from 'centric-ui-components'
import * as css from './GroupCountBadges.css'

export const GroupCountBadges = observer<{offline?: boolean}>( function GroupCountBadges({ offline }) {
  const store = useGroupByGroupStore(),
    {catalog, catalog: {catalogConfig: {perspectives}}, assortmentRoot, strings} = store

  return <div className={css.root} data-type='GroupCountBadges'>
    {assortmentRoot?.assortment && <Tooltip2 content={strings.assortment}
                                 placement='bottom'>
	    <NumberBadge active={false}
	                 data-loading={assortmentRoot.loading}
	                 className={classNames(css.perspective, css.assortmentCount)}
	                 children={assortmentRoot.loading ? <Spinner size={18}/> : assortmentRoot.assortmentCount}/>
    </Tooltip2>}

    {(_.isEmpty(perspectives) ? [{id: catalog.workspaceConfig._id, label: catalog.workspaceConfig.title}] : perspectives)
      .filter(p => !p.filter) // filter aggs don't work with composite queries
      .map(p => <GroupCountBadge key={p.id} perspective={p} offline={offline} />)}
  </div>
})

export const GroupCountBadge = observer<{ perspective?: CatalogPerspectiveConfig, hideZeroBadge?: boolean, offline?: boolean }>(function GroupCountBadge({ hideZeroBadge, perspective, offline }) {
  const {strings, countForPerspective, offlineItems, onClickPerspectiveCountButton, loading, settings: {showOnlyOfflineItems, showOnlyOnlineItems, perspective: selectedPerspectiveId}, catalog } = useGroupByGroupStore(),
    groupCount = offline ? offlineItems.length : countForPerspective(perspective),
    isActive = (offline && (showOnlyOfflineItems || catalog.settings?.showOnlyOfflineItems)) || (!offline && ((showOnlyOnlineItems && (perspective === catalog.perspective)) || (catalog.headerPerspectives.length > 1 && perspective.id == (selectedPerspectiveId ?? catalog.perspectiveId))))

  return (groupCount !== null && (groupCount !== 0 || !offline)) ? (
    <Tooltip2 content={offline ? strings.offlineItems : (pluralize(perspective?.id === catalog.workspaceConfig?._id ? catalog.catalogItemName : perspective?.label) ?? '')}
             placement='bottom'>
      <NumberBadge data-id={offline ? 'offline' : perspective?.id}
                   onClick={onClickPerspectiveCountButton({offline, perspective})}
                   active={isActive}
                   data-loading={loading}
                   style={{background: perspective?.background}}
                   className={classNames(css.perspective, {[css.offline]: offline})}
                   children={loading ? <Spinner size={18} /> : groupCount} />
    </Tooltip2>) : null
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupByCatalog_LoadMore/GroupCountBadges.tsx